import { AssetType, ZapMetadata } from "@zapier/canvas-state";
import { FloatingZapsTypeahead } from "../FloatingZapsTypeahead";
import { FloatingTablesTypeahead } from "../FloatingTablesTypeahead";
import { FloatingChatbotsTypeahead } from "../FloatingChatbotsTypeahead";
import { FloatingInterfacesAndPagesTypeaheads } from "../FloatingInterfacesAndPagesTypeaheads";
import { FloatingLinkInput } from "../FloatingLinkInput";

type Props = {
  zap?: ZapMetadata;
  hasZap?: boolean;
  isZapNotFound?: boolean;
  assetType: AssetType | undefined;
  link: string | undefined;
  assetIds:
    | {
        tableId?: string;
        interfaceProjectId?: string;
        interfacePageId?: string;
        chatbotId?: string;
      }
    | undefined;
};

export function FloatingLinkController({
  zap,
  hasZap,
  isZapNotFound,
  assetType,
  link,
  assetIds,
}: Props) {
  const tableId = assetIds?.tableId;
  const chatbotId = assetIds?.chatbotId;
  const interfaceProjectId = assetIds?.interfaceProjectId;
  const interfacePageId = assetIds?.interfacePageId;

  if (assetType === "interface") {
    return (
      <FloatingInterfacesAndPagesTypeaheads
        interfaceProjectId={interfaceProjectId}
        interfacePageId={interfacePageId}
      />
    );
  }

  if (assetType === "table") {
    return <FloatingTablesTypeahead selectedTableId={tableId} />;
  }

  if (assetType === "chatbot") {
    return <FloatingChatbotsTypeahead selectedChatbotId={chatbotId} />;
  }

  if (assetType === "zap") {
    return (
      <FloatingZapsTypeahead
        zapTitle={zap?.title}
        hasZap={hasZap}
        isZapNotFound={isZapNotFound}
      />
    );
  }

  return <FloatingLinkInput link={link} />;
}
